<template>
    <!--定点投放 新增类目/编辑类目 对话框 -->
    <el-dialog title="编辑类目" :visible.sync="show" :with-header="false" :before-close="closeDialog" width="40%">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="80px">
                    <el-form-item label="类目名字:" label-width="120px">
                        <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder" style="width: 60%"> </el-input>
                    </el-form-item>
                    <el-form-item label="类目颜色:" label-width="120px">
                        <div style="display: flex">
                            <el-input
                                v-model="submit_data.promotion_category_color"
                                :placeholder="submit_rules.promotion_category_color.placeholder"
                                style="width: 60%"
                            >
                            </el-input>
                            <el-color-picker v-model="submit_data.promotion_category_color"></el-color-picker>
                            <div style="margin-left: 10px">
                                <el-tooltip class="item" effect="dark" content="可视化数据颜色，建议每个类目使用不同颜色" placement="right">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>

                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center; margin-top: 100px">
                    <submitBtn
                        @onSubmitDig="onSubmitDig"
                        :data="submit_data"
                        :rules="submit_rules"
                        :url="submit_url"
                        :JSON_Boolean="false"
                    ></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-dialog>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: {}
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            if (_this.data.editFlag == 'edit') {
       
                // 如果是编辑按钮点击进来的

                _this.submit_url = '/promotion/editPromotionCategory';
                _this.submit_data_edit.promotion_category_code = _this.data.promotion_category_code;
                _this.submit_data_edit.name = _this.data.name;
                _this.submit_data_edit.promotion_category_color = _this.data.promotion_category_color;
                _this.submit_data = _this.submit_data_edit;
            } else if (_this.data.editFlag == 'add') {
       
                _this.submit_url = '/promotion/addPromotionCategory';
                _this.submit_data = _this.submit_data_add;
            }
        }
    },
    data() {
        return {
            show: false,

            submit_url: '/promotion/addPromotionCategory',
            submit_data: {},
            // 表单数据
            submit_data_add: {
                name: '',
                promotion_category_color: ''
            },
            // 表单数据
            submit_data_edit: {
                name: '',
                promotion_category_color: '',
                promotion_category_code: ''
            },

            submit_rules: {
                name: {
                    placeholder: '类目名字',
                    rules: {
                        required: true,
                        message: '类目名字错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                promotion_category_color: {
                    placeholder: '类目色',
                    rules: {
                        required: true,
                        message: '类目数量错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
   
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.submit_data = {};
            _this.submit_data_add = {
                name: '',
                promotion_category_color: ''
            };
            _this.submit_data_edit = {
                name: '',
                promotion_category_color: '',
                promotion_category_code: ''
            };
        },

        // 提交
        onSubmitDig() {
            _this.$emit('onSubmit');
            _this.closeDialog();
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

</style>
